export default __webpack_public_path__ + "images/f8024094d23ea1871554502a87821d98.png";